import { ToastAlertType } from '@freelancer/ui/toast-alert';

export const contactsToastDetails = {
  CONTACTS_SYNC_SUCCESS: {
    id: 'ContactsSyncSuccess',
    type: ToastAlertType.SUCCESS,
    message: $localize`Your contacts are now synced.`,
  },
  CONTACTS_UNSYNC_SUCCESS: {
    id: 'ContactsUnsyncSuccess',
    type: ToastAlertType.SUCCESS,
    message: $localize`Your synced contacts are now removed.`,
  },
  CONTACTS_SYNC_ERROR: {
    id: 'ContactsSyncError',
    type: ToastAlertType.ERROR,
    message: $localize`Something went wrong while updating your synced contacts. Please try again.`,
  },
  VISIBILITY_ON_SUCCESS: {
    id: 'VisibilityOnSuccess',
    type: ToastAlertType.SUCCESS,
    message: $localize`Your contacts will now see your account.`,
  },
  VISIBILITY_OFF_SUCCESS: {
    id: 'VisibilityOffSuccess',
    type: ToastAlertType.SUCCESS,
    message: $localize`Your account visibility is now turned off.`,
  },
  VISIBILITY_UPDATE_ERROR: {
    id: 'VisibilityUpdateError',
    type: ToastAlertType.ERROR,
    message: $localize`Something went wrong while updating your account visibility. Please try again.`,
  },
};
